class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.enableHover = this.dataset.hover;
    this.header = document.querySelector('.header-wrapper');
    const _this = this;

    if (this.enableHover == 'true') {
      this.mainDetailsToggle.onmouseover = (e) => {
        if (this.closeTimer) clearTimeout(this.closeTimer);
        if (!this.mainDetailsToggle.hasAttribute('open')) {
          this.open();
        }
      };

      this.mainDetailsToggle.onmouseleave = (e) => {
        this.closeTimer = setTimeout(() => {
          _this.close();
        }, 300);
      };
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.onToggle();
  }

  closeOtherContents(e) {
    this.querySelectorAll('header-menu details').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary').setAttribute('aria-expanded', false);
    });
  }
}

customElements.define('header-menu', HeaderMenu);
